import React from "react";
import { Reveal, SectionHeading } from "./_shared";
import { motion } from "framer-motion";
import {
    DashboardMock, FormazioneMock, CalendarMock, ReportMock,
    SopralluoghiMock, RegistriMock,
} from "../mocks/DashboardMocks";

const previews = [
    {
        component: DashboardMock,
        caption: "Panoramica cliente — Un colpo d'occhio su aziende, lavoratori, sopralluoghi e scadenze critiche.",
    },
    {
        component: FormazioneMock,
        caption: "Formazione — Corsi validi, in scadenza o scaduti, con nominativi resi anonimi per la privacy.",
        note: "Nomi dei lavoratori sfocati per riservatezza.",
    },
    {
        component: RegistriMock,
        caption: "Registri e dossier sempre disponibili — Documenti, registrazioni e dossier aziendali raccolti in formato digitale, consultabili senza ricorrere ad archivi cartacei.",
        highlight: true,
        badge: "NOVITÀ",
    },
    {
        component: CalendarMock,
        caption: "Calendario scadenze — Appuntamenti, visite mediche, corsi e revisioni sullo stesso piano.",
    },
    {
        component: SopralluoghiMock,
        caption: "Sopralluoghi — Programmazione delle attività da svolgere presso le aziende.",
        note: "Nomi delle aziende sfocati.",
    },
    {
        component: ReportMock,
        caption: "Report — Riepiloghi Excel di formazione, visite, DPI, HACCP e sicurezza.",
    },
];

export default function AppPreview() {
    return (
        <section id="anteprima" className="relative py-24 md:py-32 bg-navy-50">
            <div className="max-w-[1400px] mx-auto px-5 md:px-8">
                <SectionHeading
                    chapter={6}
                    chapterLabel="Anteprima"
                    title={<>Guarda SafetyDesk81 <span className="text-navy-400">in anteprima.</span></>}
                />
                <Reveal delay={0.15}>
                    <p className="mt-6 max-w-2xl text-navy-600 text-lg leading-relaxed">
                        Una dashboard intuitiva per avere una visione immediata di aziende, lavoratori, corsi,
                        sopralluoghi e scadenze — con l'aggiunta di registri digitali e dell'agente AI.
                    </p>
                </Reveal>

                {/* Previews start directly with Panoramica */}
                <div className="mt-16 space-y-24 md:space-y-32">
                    {previews.map((p, i) => {
                        const Comp = p.component;
                        const flip = i % 2 === 1;
                        return (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.2 }}
                                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                                className={`grid lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] gap-10 items-center ${flip ? "lg:[&>*:first-child]:order-2" : ""}`}
                                data-testid={`preview-${i}`}
                            >
                                <div>
                                    <Comp animate={false} />
                                </div>
                                <div className={flip ? "lg:pr-8" : "lg:pl-8"}>
                                    <div className="chapter-chip mb-5">
                                        <span className="num">{`0${i + 1}`.slice(-2)}</span>
                                        <span className="text-navy-500">Sezione</span>
                                    </div>
                                    {p.badge && (
                                        <span className="inline-block mb-3 text-[10px] font-bold uppercase tracking-widest bg-gold-400 text-navy-950 px-2 py-1 rounded-full">{p.badge}</span>
                                    )}
                                    <p className={`font-display font-bold text-navy-950 leading-snug ${p.highlight ? "text-3xl md:text-4xl" : "text-2xl md:text-3xl"}`}>
                                        {p.caption.split(" — ")[0]}
                                    </p>
                                    <p className="mt-4 text-navy-600 text-lg leading-relaxed">
                                        {p.caption.split(" — ")[1]}
                                    </p>
                                    {p.note && (
                                        <p className="mt-3 text-[11px] font-mono text-navy-400 uppercase tracking-widest">
                                            {p.note}
                                        </p>
                                    )}
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
